import React from 'react';
import { REPORTS_EDIT_REPORT } from 'routes';
import {
  AppBar,
  AppBarDataCustomItem,
  Button,
  HeaderTabs,
  ScrollableViewport,
} from '@ihsm/ui-shared';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from 'state/store';
import playIcon from 'shared/assets/icons/play.svg';
import { currentReportSelector } from 'state/store/selectors';
import { useGetReportsQuery } from 'services/newApi/reportsConfigApi';
import { TransparentButton } from 'shared/components/Buttons';
import { PageContent } from 'shared/components/PageContent';
import { InnerPagePadding } from 'shared/components/InnerPagePadding/InnerPagePadding';
import { SearchTreeReports } from '../components/SearchTreeReports';
import { NewReportForm } from '../components/NewReportForm';
import { useRunReportForm, useHeaderTabs } from '../hooks';
import { RunReportModalForm } from '../components/RunReportModalForm';
import { HeaderButtonWrapper } from '../components/HeaderButtonWrapper';

export const ConfigReport: React.FC = () => {
  useGetReportsQuery();

  const {
    form,
    setForm,
    isLoading,
    isModalVisible,
    runReport,
    setModalVisible,
  } = useRunReportForm();
  const currentReport = currentReportSelector(useAppSelector((state) => state));
  const headerTabs = useHeaderTabs();
  const { push } = useHistory();

  const editButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <TransparentButton
          text="Edit"
          onClick={() => push(REPORTS_EDIT_REPORT)}
          iconSrc="Edit"
          disabled={false}
        />
      </HeaderButtonWrapper>
    ),
  };

  const runReportButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <Button
          text="Run Report"
          onClick={() => setModalVisible(true)}
          iconSrc={playIcon}
          disabled={!currentReport}
        />
      </HeaderButtonWrapper>
    ),
  };

  return (
    <>
      <PageContent
        searchTree={<SearchTreeReports />}
        headerControls={
          <AppBar menuItems={[editButton, runReportButton]}>
            <HeaderTabs items={headerTabs} />
          </AppBar>
        }
      >
        {currentReport ? (
          <ScrollableViewport vertical>
            <InnerPagePadding>
              <NewReportForm form={currentReport} isDisabled />
            </InnerPagePadding>
          </ScrollableViewport>
        ) : null}
      </PageContent>

      <RunReportModalForm
        form={form}
        setForm={setForm}
        onRun={runReport}
        onCancel={() => setModalVisible(false)}
        isLoading={isLoading}
        isVisible={isModalVisible}
        setVisible={setModalVisible}
      />
    </>
  );
};
